import { render, staticRenderFns } from "./NeuroAtlas.vue?vue&type=template&id=8f040ed6&scoped=true&"
import script from "./NeuroAtlas.vue?vue&type=script&lang=js&"
export * from "./NeuroAtlas.vue?vue&type=script&lang=js&"
import style0 from "./NeuroAtlas.vue?vue&type=style&index=0&id=8f040ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f040ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VFlex,VLayout,VSelect,VSwitch})
